<template>
  <v-container class="py-0 max-width-1200 height-300">
    <v-row class="pb-8 text-left justify-end h-100">

      <v-col class="px-6 max-width-300">
        <v-row>
          <v-col class="pb-0 font-size-xs">
            {{$t('ipsum.joinUs')}}
          </v-col>
        </v-row>
        <v-row>
          <div class="pl-3 pt-1 text-uppercase font-size-sm">
            <v-card
              flat
              @click="loadPage('Career')">
                {{$t('ipsum.jobs')}}
            </v-card>
          </div>
        </v-row>

        <v-row>
          <v-col class="pb-0">
            <v-btn
              v-for="(item,index) in socialMedia"
              :key="index"
              :title="item.name"
              :name="item.name"
              @click="openLink(item.link)"
              icon>
              <v-icon>
                {{ item.icon }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0 font-size-xs">
            © Copyright 2021 Rubin Informatikai Zrt.<br> All Rights Reserved.
          </v-col>
        </v-row>
        <v-row>
          <v-col class="font-size-xs">
            <v-card
              flat
              @click="gdpr.dialog = true">
                {{$t('ipsum.gdpr')}}
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col  class="pb-0 font-size-xs">
            <!-- <img src="@/assets/cert-familyfriendly-2020.png" style="max-height:54px" class="cert-img"> -->
            <img
              src="@/assets/cert-familyfriendly-2020.png"
              loading="lazy"
              alt="Családbarát Hely 2020"
              title="A Rubin Informatikai Zrt. tanúsított bronz fokozatú családbarát munkahely [2020]."
              height="60" width="60"
              class="mr-4 cert-img">
            <img
              src="@/assets/cert-iso-9001.jpg"
              loading="lazy"
              alt="ISO 9001 minősítés"
              title="A Rubin Informatikai Zrt. minőségirányítási rendszere megfelel az MSZ EN ISO 9001:2015 szabványnak."
              height="64" width="64"
              class="ml-4 mr-1 cert-img">
            <img
              src="@/assets/cert-iso-27001.jpg"
              loading="lazy"
              alt="ISO 27001 minősítés"
              title="A Rubin Informatikai Zrt. minőségirányítási rendszere megfelel az MSZ ISO/IEC 27001:2014 szabványnak."
              height="64" width="64"
              class="cert-img">
          </v-col>
        </v-row>
      </v-col>

    </v-row>

    <!-- DIALOG -->

    <v-dialog
      v-model="gdpr.dialog"
      width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{$t("gdpr.title")}}
          </span>
        </v-card-title>
        <v-card-subtitle>
          <span class="">
            {{$t("gdpr.subtitle")}}
          </span><br>
        </v-card-subtitle>
        <v-card-subtitle>
          <span class="">
            {{$t("gdpr.text")}}
          </span>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text class="pt-4 text-justify max-height-500 overflow-y">
          <h3>{{$t("gdpr.p01.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p01.text'))"></div>
          <h3>{{$t("gdpr.p02.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p02.text'))"></div>
          <h3>{{$t("gdpr.p03.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p03.text'))"></div>
          <h3>{{$t("gdpr.p04.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p04.text'))"></div>
          <h3>{{$t("gdpr.p05.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p05.text'))"></div>
          <h3>{{$t("gdpr.p06.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p06.text'))"></div>
          <h3>{{$t("gdpr.p07.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p07.text'))"></div>
          <h3>{{$t("gdpr.p08.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p08.text'))"></div>
          <h3>{{$t("gdpr.p09.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p09.text'))"></div>
          <h3>{{$t("gdpr.p10.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p10.text'))"></div>
          <h3>{{$t("gdpr.p11.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p11.text'))"></div>
          <h3>{{$t("gdpr.p12.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p12.text'))"></div>
          <h3>{{$t("gdpr.p13.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p13.text'))"></div>
          <h3>{{$t("gdpr.p14.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p14.text'))"></div>
          <h3>{{$t("gdpr.p15.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p15.text'))"></div>
          <h3>{{$t("gdpr.p16.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p16.text'))"></div>
          <h3>{{$t("gdpr.p17.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p17.text'))"></div>
          <h3>{{$t("gdpr.p18.title")}}</h3>
          <div v-html="parseHtml($t('gdpr.p18.text'))"></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="gdpr.dialog = false">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Promo',
    extends: DataComponentBase,

    data: () => ({
      switch1: false,
      socialMedia: [
        { icon: 'mdi-facebook',   name: 'facebook',   link: 'https://www.facebook.com/rubininformatika' },
        { icon: 'mdi-twitter',    name: 'twitter',    link: 'https://twitter.com/RubinZrt' },
        { icon: 'mdi-instagram',  name: 'instagram',  link: 'https://www.instagram.com/rubininformatika/' },
        { icon: 'mdi-linkedin',   name: 'linkedin',   link: 'https://www.linkedin.com/company/rubin-informatikai-zrt-' },
      ],
      gdpr: {
        dialog: false,
      }
    }),

    methods: {
      parseHtml(rawText) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(rawText, "text/html");
        return doc.querySelector("body").innerHTML;
      },
      openLink(link) {
        let url = link;
        window.open(url,'_blank');
      },
    }
  }
</script>
